(function () {
  'use strict';
  function closeAll(except) {
    document.querySelectorAll('.card.is-quick').forEach(function (c) {
      if (c === except) return;
      c.classList.remove('is-quick');
      var b = c.querySelector('[data-quick-toggle]');
      if (b) { b.setAttribute('aria-expanded', 'false'); b.textContent = '+'; }
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-toggle]');
    if (btn) {
      e.preventDefault();
      var card = btn.closest('.card');
      var open = !card.classList.contains('is-quick');
      closeAll(card);
      card.classList.toggle('is-quick', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.innerHTML = open ? '&times;' : '+';
      return;
    }
    if (!e.target.closest('.card__quick')) closeAll(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
})();

/* Swipeable card photos: dots follow the swipe, arrows on desktop */
(function () {
  'use strict';
  function sync(track) {
    var w = track.clientWidth || 1;
    var i = Math.round(track.scrollLeft / w);
    var dots = track.parentNode.querySelectorAll('.card__dot');
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === i);
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.hasAttribute && t.hasAttribute('data-card-slides')) sync(t);
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-prev], [data-card-next]');
    if (!btn) return;
    e.preventDefault();
    var track = btn.closest('.card').querySelector('[data-card-slides]');
    if (!track) return;
    var w = track.clientWidth;
    var max = track.scrollWidth - w;
    var next = track.scrollLeft + (btn.hasAttribute('data-card-next') ? w : -w);
    if (next > max + 2) next = 0;
    if (next < -2) next = max;
    track.scrollTo({ left: next, behavior: 'smooth' });
  });
})();

/* RAPI bundle check: if RAPI shows its bundle on this product, hide the bottom
   "You may also like" row so the page doesn't repeat itself. Products without
   RAPI keep the row. Recently viewed always stays. */
(function () {
  'use strict';
  var pdp = document.querySelector('[data-product-section]');
  if (!pdp) return;
  function looksLikeRapi(el) {
    var cls = typeof el.className === 'string' ? el.className : '';
    var text = (el.tagName + ' ' + (el.id || '') + ' ' + cls + ' ' + el.getAttributeNames().join(' ')).toLowerCase();
    return text.indexOf('rapi') > -1 && el.offsetHeight > 40;
  }
  function check() {
    var els = pdp.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      if (looksLikeRapi(els[i])) {
        document.documentElement.classList.add('has-rapi-bundle');
        return true;
      }
    }
    return false;
  }
  if (check()) return;
  var obs = new MutationObserver(function () { if (check()) obs.disconnect(); });
  obs.observe(pdp, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 12000);
})();
